import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { GET_CONTACTS, UPDATE_CONTACT_STATUS, ADD_CONTACT, EDIT_CONTACT, DELETE_CONTACT, UPDATE_CONTACT_ORDER_STATUS } from "../Constants";
import { defaultHeaders } from "../Constants/DefaultHeaders";
import { logout } from "../../utils";
import { GetContactsSuccess, GetContactsFailure, UpdateContactStatusSuccess, UpdateContactStatusFailure, AddContactSuccess, AddContactFailure, EditContactSuccess, EditContactFailure, DeleteContactSuccess, DeleteContactFailure, UpdateContactOrderStatusSuccess, UpdateContactOrderStatusFailure } from "../Actions/ContactUsAction";

function* GetContactsRequest(actions) {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/contacts?status=`, {
      headers: defaultHeaders(),
    });
    if (res.status === 200) {
      yield put(GetContactsSuccess(res.data));
    } else {
      yield put(GetContactsFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetContactsFailure(e));
  }
}

function* contactStatusRequest(actions) {
  const body = {
    id: actions.payload.id,
    status: actions.payload.status,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/change_contact_status`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(UpdateContactStatusSuccess(res.data));
    } else yield put(UpdateContactStatusFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateContactStatusFailure(e));
  }
}

function* addContactRequest(actions) {
  function getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  }
  const body = {
    title: actions.payload.title,
    icon: actions.payload.icon,
    type: actions.payload.type,
    information: actions.payload.information,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/add_contact`, getFormData(body), { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(AddContactSuccess(res.data));
    } else yield put(AddContactFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(AddContactFailure(e));
  }
}

function* editContactRequest(actions) {
  function getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  }
  const body = {
    id: actions.payload.id,
    title: actions.payload.title,
    icon: actions.payload.icon,
    type: actions.payload.type,
    information: actions.payload.information,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/edit_contact`, getFormData(body), { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(EditContactSuccess(res.data));
    } else yield put(EditContactFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(EditContactFailure(e));
  }
}

function* deleteContactRequest(actions) {
  try {
    const res = yield axios.delete(`${process.env.REACT_APP_API_URL}api/admin/contact/${actions.payload}`, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(DeleteContactSuccess(res.data));
    } else yield put(DeleteContactFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(DeleteContactFailure(e));
  }
}

function* contactOrderStatusRequest(actions) {
  let data = [];
  actions.payload.map((arr) => {
    data.push(arr);
  });
  const body = {
    data,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/change_contact_order_number`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(UpdateContactOrderStatusSuccess(res.data));
    } else yield put(UpdateContactOrderStatusFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateContactOrderStatusFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(GET_CONTACTS, GetContactsRequest);
  yield takeLatest(UPDATE_CONTACT_STATUS, contactStatusRequest);
  yield takeLatest(ADD_CONTACT, addContactRequest);
  yield takeLatest(EDIT_CONTACT, editContactRequest);
  yield takeLatest(DELETE_CONTACT, deleteContactRequest);
  yield takeLatest(UPDATE_CONTACT_ORDER_STATUS, contactOrderStatusRequest);
}

export default function* ContactUsSaga() {
  yield all([actionWatcher()]);
}
